<template>
  <sb-card :title="title"
           :loading="loading"
           min-width="100%">
    <v-container :class="{'disable-pointer': !canEditCollection}">
      <v-row>
        <v-col cols="12"
               sm="6"
               class="py-0">
          <sb-text-field label="Collected By"
                         @input-with-label="onInputWithLabel" />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12"
               sm="3"
               class="py-0">
          <sb-date-picker-field label="Collection Date"
                                ref-name="collectionDate"
                                @input-with-label="onInputWithLabel" />
        </v-col>
        <v-col cols="12"
               sm="3"
               class="py-0">
          <sb-time-picker label="Collection Time"
                          ref-name="collectionTime"
                          @input-with-label="onInputWithLabel" />
        </v-col>
      </v-row>
    </v-container>
  </sb-card>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    canEditCollection: {
      type: Boolean,
      default: false,
    },

  },

  methods: {
    onInputWithLabel(value) {
      this.$emit('collection-update', value);
    },
  },

};
</script>
